import { useExperimentalFeature } from "@istari-frontend/experimental-features";
import { useCallback } from "react";

import { getNotificationUrl } from "~/notifications/feature/get-notification-url";
import type { Notification } from "~/notifications/model/notification";

export function useNotificationUrl() {
  const { enabled } = useExperimentalFeature("system-redesign");

  return useCallback(
    (notification: Notification) => getNotificationUrl(notification, { systemRedesign: enabled }),
    [enabled],
  );
}
